import { useEffect } from 'react'

import { useSelector } from '@tabeeb/store'
import { getFormsTitle } from '@tabeeb/modules/appConfigState/selectors'

import { formTitleFormatter } from './FormTitleFormatter'

const useFormTitleFormatter = () => {
  const title = useSelector(getFormsTitle)

  useEffect(() => {
    formTitleFormatter.setTitle(title)
  }, [title])

  return {
    f: formTitleFormatter.format.bind(formTitleFormatter),
  }
}

export default useFormTitleFormatter
